{
  "name": "online-membership-sales",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:docker": "ng build -c=docker --output-hashing=bundles",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.25",
    "@angular/common": "21.2.25",
    "@angular/compiler": "21.2.25",
    "@angular/core": "21.2.25",
    "@angular/forms": "21.2.25",
    "@angular/platform-browser": "21.2.25",
    "@angular/platform-browser-dynamic": "21.2.25",
    "@angular/router": "21.2.25",
    "@bayclubs/alert": "13.0.0",
    "@bayclubs/drop-down": "13.2.0",
    "@bayclubs/logging": "10.0.0",
    "@bayclubs/spinner": "13.0.0",
    "@bayclubs/ui-text-mask": "4.0.0",
    "@bayclubs/utils": "13.0.0",
    "ngx-toastr": "20.0.5",
    "@ngx-translate/core": "18.0.0",
    "@ngx-translate/http-loader": "18.0.0",
    "@nicky-lenaers/ngx-scroll-to": "14.0.0",
    "bootstrap": "4.3.1",
    "guid-typescript": "1.0.9",
    "jquery": "3.4.1",
    "moment": "2.30.1",
    "moment-timezone": "0.6.3",
    "ng-click-outside": "9.0.1",
    "ng-recaptcha": "13.2.1",
    "ngx-bootstrap": "21.2.2",
    "ngx-device-detector": "11.0.0",
    "ngx-mask": "21.1.0",
    "firebase": "^11.0.0",
    "@grafana/faro-web-sdk": "2.3.1",
    "@grafana/faro-web-tracing": "2.3.1",
    "lodash": "4.18.1",
    "rxjs": "7.8.2",
    "stacktrace-js": "2.0.1",
    "text-mask-addons": "3.8.0",
    "tslib": "2.8.1",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "21.2.28",
    "@angular/cli": "21.2.28",
    "@angular/compiler-cli": "21.2.25",
    "@angular/language-service": "21.2.25",
    "@types/jasmine": "5.1.9",
    "@types/node": "^22.0.0",
    "jasmine-core": "5.9.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage-istanbul-reporter": "3.0.3",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.3.0",
    "sass": "1.69.5",
    "typescript": "5.9.3"
  }
}
